import React, { createContext, useContext, useMemo, useState } from 'react';

type RangeKey = '7d' | '30d' | 'all';

interface StatisticsRangeValue {
  rangeKey: RangeKey;
  setRangeKey: (v: RangeKey) => void;
}

const StatisticsRangeContext = createContext<StatisticsRangeValue | undefined>(
  undefined,
);

export function StatisticsRangeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [
    rangeKey,
    setRangeKey,
  ] = useState<RangeKey>('all');
  const value = useMemo(() => ({ rangeKey, setRangeKey }), [rangeKey]);
  return (
    <StatisticsRangeContext.Provider value={value}>
      {children}
    </StatisticsRangeContext.Provider>
  );
}

export function useStatisticsRange(): StatisticsRangeValue {
  const ctx = useContext(StatisticsRangeContext);
  if (!ctx)
    throw new Error(
      'useStatisticsRange must be used within StatisticsRangeProvider',
    );
  return ctx;
}
